import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams, Route, Routes } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  Card,
  Grid,
  Flex,
  Title,
  Modal,
  ActionIcon,
  Anchor,
} from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";

import { SongForm, SongSettings } from "@components/Song";
import { CurationTagManagement, TransferSong } from "@components/Curation";
import { ErrorView, PageTitle, Subnav } from "@components/shared";

import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

import { formatArtistList } from "@components/Curation/helpers";

export default function SongDetail() {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [editing, setEditing] = useState(false);
  const params = useParams();
  const { id } = params;

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios
      .get(`/songs/${id}/`)
      .then(({ data }) => {
        setInfo({
          ...data.response[0],
          name: data.response[0].name || "???",
        });
      })
      .catch((err) => {
        setError(err);
        setInfo(null);
      });
  }

  if (error) {
    return <ErrorView text={error} />;
  }

  if (!info) return null;

  return (
    <div>
      <PageTitle
        title={
          <Flex align="center" gap="xs">
            <span>{info.name}</span>
            <ActionIcon
              variant="light"
              onClick={() => setEditing(true)}
              radius="xl"
              size="md"
              color="gray"
            >
              <IconEdit size={16} />
            </ActionIcon>
            <TransferSong
              songName={info.name}
              songId={id}
              songInfo={info}
              onSuccess={fetchData}
              artist={info.artists[0]}
              iconButton
            />
          </Flex>
        }
        subtitle={
          <Flex gap={5}>
            Song from{" "}
            {info.artists ? (
              <Flex gap="xs">
                {info.artists.map((artist) => (
                  <Anchor
                    component={Link}
                    to={`/artists/${artist.id}`}
                    key={artist.id}
                  >
                    {artist.name}
                  </Anchor>
                ))}
              </Flex>
            ) : (
              ""
            )}
          </Flex>
        }
        icon={entityIcon.song()}
        style={{ marginBottom: "1em" }}
      />
      <Routes>
        <Route
          exact
          path="/"
          element={
            <React.Fragment>
              <Modal opened={editing} onClose={() => setEditing(false)}>
                <SongForm
                  id={id}
                  name={info.name}
                  onSuccess={() => {
                    fetchData();
                    setEditing(false);
                  }}
                />
              </Modal>
              <SongSettings songId={id} />
              <Grid mt="lg">
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <Title mb="sm" order={4}>
                    Tags
                  </Title>
                  <Card mb="sm">
                    <CurationTagManagement
                      songId={id}
                      items={info.tags}
                      fetchData={fetchData}
                    />
                  </Card>
                </Grid.Col>
              </Grid>
            </React.Fragment>
          }
        />
      </Routes>
    </div>
  );
}
